import React, { useContext } from "react";
import RequestPreview from "./preview/RequestPreview";
import { isTouch } from "../../../utils/screenUtil";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { DELETE } from "../../../utils/fetchUtil";
import { MessageContext } from "../../../common/message";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt } from "@fortawesome/free-solid-svg-icons";

function InMaking({ title, requests, activeJournalId, setActiveJournalId, setInMaking }) {
  const history = useHistory();
  const { t } = useTranslation();
  const message = useContext(MessageContext);

  const deleteRequest = (request) => {
    message.toggle({
      title: t("requests.overview.inMaking.deleteRequest.title"),
      content: t("requests.overview.inMaking.deleteRequest.content"),
      onNo: () => message.toggle({}),
      onYes: () => {
        DELETE(`/requests/${request.id}/submissions/${request.uid}`, () => {
          message.toggle({});
          let reducedRequests = requests.reduce((accumulator, current) => {
            if (current.id !== request.id || current.uid !== request.uid) {
              accumulator.push(current);
            }
            return accumulator;
          }, []);
          setInMaking(reducedRequests);
        });
      },
    });
  };

  return (
    <>
      <div className="subtitle">{title}</div>
      {requests &&
        requests.map((request, index) => (
          <RequestPreview
            className={isTouch() && index > 0 ? "mt-6" : ""}
            key={`inMaking${index}`}
            blur={activeJournalId && activeJournalId !== request.uid}
            setActiveJournalId={setActiveJournalId}
            deleteRequest={() => deleteRequest(request)}
            {...request}
            renderRequestActions={() => (
              <>
                {request.error && (
                  <FontAwesomeIcon icon={faRedoAlt} size="2x" className="is-clickable mr-2" />
                )}
                <FontAwesomeIcon
                  className="ml-4 is-clickable"
                  icon={faEdit}
                  onClick={() =>
                    history.push(
                      `/submitRequest?id=${request.id}&title=${request.title}&uid=${request.uid}`
                    )
                  }
                  size="2x"
                />
              </>
            )}
            renderGeneralActions={() => (
              <FontAwesomeIcon
                icon={faTrashAlt}
                size="2x"
                className="is-pulled-right has-text-danger is-clickable mr-2"
                onClick={() => deleteRequest(request)}
              />
            )}
          />
        ))}
    </>
  );
}

export default InMaking;
